export default import.meta.ROLLDOWN_FILE_URL_s4Bi55MYUqNrp1DXScH0kA